import { DropZone } from "@measured/puck";
import { Box, useTheme } from "@mui/material";

export type SpaceProps = {
    height?: number;
};

export const Space = (props: SpaceProps) => {
    const { height = 4 } = props;

    const theme = useTheme();

    return (
        <Box
            sx={{
                height: theme.spacing(height),
                width: "100%",
                position: "relative",
            }}
        >
            <DropZone
                zone="space"
                allow={[]}
                style={{
                    minHeight: theme.spacing(height),
                    height: "100%",
                }}
            />
        </Box>
    );
};
